import { doctorAnalyticAction } from "app/store/dashboard/doctor_analytic/actions/doctorAnalyticAction";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  account: "all",
  sort: "highest",
  name: "",
  startDate: "",
  endDate: "",
};

const doctorAnalyticSlice = createSlice({
  name: "doctorAnalytic",
  initialState: initialState,
  reducers: doctorAnalyticAction,
});

export const {
  yearFilter,
  monthFilter,
  accountFilter,
  sortFilter,
  nameFilter,
  resetFilter,
  changeFilter,
} = doctorAnalyticSlice.actions;

export default doctorAnalyticSlice.reducer;
